/* eslint-disable promise/always-return */

/* eslint-disable max-lines-per-function */

/* eslint-disable promise/avoid-new */

/* eslint-disable promise/catch-or-return */
import React from 'react';

import {
  DateFormatService,
  StorageOfUniqueServices,
  TestExecutionService,
} from '@qality/common-service';
import { TestExecutionPageContext } from '@qality/common-state';
import { TestExecutionHistoryUtils } from '@qality/common-utils';

import { ExecutionHistoryContext } from './ExecutionHistoryContext';

export const ExecutionHistoryProvider = ({ issueKey = '', children }: any) => {
  // reported-bugs, failed-steps
  const [displayedTab, setDisplayedTab] = React.useState('reported-bugs');
  const [historyDetails, setHistoryDetails] = React.useState({});
  const [bugsReported, setBugsReported] = React.useState();
  const [failedSteps, setFailedSteps] = React.useState();
  const { testExecution } = React.useContext(TestExecutionPageContext);

  const executionsHistoryUrl = StorageOfUniqueServices.get(
    'URLService'
  ).getTestCaseExecutionHistoryUrl(issueKey, issueKey);

  const getTestCaseExecutionUrl = async (testExecutionId) => {
    const testCaseExecutionUrl = await StorageOfUniqueServices.get(
      'URLService'
    ).getEmptyTestCaseExecutionUrl();

    return testCaseExecutionUrl + testExecutionId;
  };

  const handleChangeTab = (tabName) => {
    setDisplayedTab(tabName);
  };

  const fetchHistoryDetails = () => {
    TestExecutionService.getTestExecutionHistoryDetails(testExecution.id).then(
      // eslint-disable-next-line complexity
      async (historyDetailsResponseBody) => {
        const previousExecution = historyDetailsResponseBody.previousExecution;
        const previousExecutionUrl = previousExecution?.id
          ? await getTestCaseExecutionUrl(previousExecution.id)
          : null;

        if (previousExecution) {
          //TODO: remove after status cleanup
          previousExecution.status = previousExecution.statusObject;
        }

        setHistoryDetails({
          executionsCount: historyDetailsResponseBody.numberOfExecutions,
          executionsHistoryUrl,
          previousExecutionStatus: previousExecution?.status ?? null,
          previousExecutionUrl,
          previousExecution:
            previousExecution?.createdDate &&
            DateFormatService.formatDate(
              previousExecution.createdDate,
              'longDateFormat'
            ),
          lastFailedExectution:
            historyDetailsResponseBody.lastFailed &&
            DateFormatService.formatDate(
              historyDetailsResponseBody.lastFailed,
              'longDateFormat'
            ),
        });
      }
    );
  };

  const fetchBugsReported = async () => {
    if (bugsReported) {
      return;
    }

    const reportedBugsResponse =
      await TestExecutionService.getTestExecutionReportedBugs(
        testExecution.testCaseId
      );

    const issueIds = reportedBugsResponse.data.bugsReported.map(
      ({ linkedIssueId }) => linkedIssueId
    );

    const issuesList = await StorageOfUniqueServices.get(
      'JQLSearchService'
    ).bulkFetchIssuesByIds({
      ids: issueIds,
      fields: ['summary', 'issuetype', 'created', 'status', 'reporter'],
      maxResults: 50,
    });

    const bugsReportedFormatted = reportedBugsResponse.data.bugsReported
      .map((reportedBug) => {
        const issue = issuesList.find(
          (i) => `${i.id}` === `${reportedBug.linkedIssueId}`
        );
        if (!issue) {
          return null;
        }

        return TestExecutionHistoryUtils.formatReportedBug(reportedBug, issue);
      })
      .filter(Boolean)
      .sort((bugA, bugB) => {
        return (
          new Date(bugB.linkedIssue?.created) -
          new Date(bugA.linkedIssue?.created)
        );
      });

    setBugsReported(bugsReportedFormatted);
  };

  const fetchFailedSteps = async () => {
    if (failedSteps) {
      return;
    }

    const failedStepsResponse =
      await TestExecutionService.getTestExecutionFailedSteps(
        testExecution.testCaseId
      );

    const failedStepsFormatted = failedStepsResponse.data.failedSteps.map(
      (failedStep) => {
        return TestExecutionHistoryUtils.formatFailedStep(failedStep);
      }
    );
    setFailedSteps(failedStepsFormatted);
  };

  React.useEffect(() => {
    switch (displayedTab) {
      case 'reported-bugs':
        fetchBugsReported();
        break;
      case 'failed-steps':
        fetchFailedSteps();
    }
  }, [displayedTab]);

  React.useEffect(() => {
    fetchHistoryDetails();
  }, []);

  return (
    <ExecutionHistoryContext.Provider
      value={{
        failedSteps,
        bugsReported,
        historyDetails,
        handleChangeTab,
        currentTab: displayedTab,
      }}
    >
      {children}
    </ExecutionHistoryContext.Provider>
  );
};
